<template>
  <div class="nav">
    <div class="container">
      <ul>
        <li><router-link to="/">Présentation</router-link></li><span> |</span>
        <li><router-link to="/ressources">Ressources</router-link></li><span> |</span>
        <li><router-link to="/processing">Processing</router-link></li><span> |</span>
        <li><router-link to="/jingle">Jingle</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nav',
}
</script>
<style>
  .nav{
    height:50px;
    padding-top:12px;
    background-color:#ccc;
  }

  @media screen and (max-width: 410px){
    .nav{
      height:30px;
      padding-top:5px;
    }
  }

  .nav li,
  .nav span{
    font-size: 18px;
  }

  @media screen and (max-width: 410px){
    .nav li,
    .nav span{
      font-size: 12px;
    }
  }

  ul{padding:0;}

  li{
    display:inline;
    cursor: pointer;
  }

  li a  {
    color: #333;
    text-decoration: none;
  }
  li a:hover {
    color:#595959;
    text-decoration: none;
  }

  li a:focus {
    color:#808080;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// MainNav.vue?4a3217f8